import { isNone } from '@ember/utils';
import {
  SerializedLegacyAttributeFilterAnd,
  SerializedLegacyAttributeFilterOr,
  SerializedLegacyAttributeFilters,
} from 'cio/types/conditions/legacy-filter';
import { isGroupCondition } from 'cio/utils/conditions/serialize';
import RelationshipCondition from 'cio/app-models/conditions/relationship';
import ObjectAttributeCondition from 'cio/app-models/conditions/object-attribute';
import { serializeFilter } from './attribute';

export function serializeFilters(
  filters: ObjectAttributeCondition[],
  operator: 'or' | 'and',
  useInverse = true,
  useComparisonOperator = false,
): SerializedLegacyAttributeFilters | Record<string, never> {
  let serialized = filters
    .compact()
    .map((f) => {
      if (isGroupCondition(f)) {
        return serializeFilters(
          f.children as ObjectAttributeCondition[],
          f.operator,
          useInverse,
          useComparisonOperator,
        );
      }

      let result = serializeFilter(f as ObjectAttributeCondition, useInverse, false, useComparisonOperator);
      return { [f.objectAttributeSource]: result };
    })
    .filter((f) => !isNone(f));

  if (serialized.length === 0) {
    return {};
  }

  if (operator === 'or') {
    return {
      or: serialized,
    } as SerializedLegacyAttributeFilterOr;
  }
  return {
    and: serialized,
  } as SerializedLegacyAttributeFilterAnd;
}

export default function (obj: RelationshipCondition) {
  let { filters, filterOperator, typeId, inverse } = obj;
  let serializedFilters = serializeFilters(filters, filterOperator);
  let andFilters: any[] = [
    {
      relationship: {
        type_id: Number(typeId),
        inverse,
      },
    },
  ];

  if (Object.keys(serializedFilters).length > 0) {
    andFilters.push(serializedFilters);
  }

  return {
    and: andFilters,
  };
}
